<ng-container *ngIf="layout === 'spaceship-start'">
    <div class="topbar__item-text"><a class="topbar__link" routerLink="/about-us">{{ 'LINK_ABOUT_US'|translate }}</a></div>
    <div class="topbar__item-text"><a class="topbar__link" routerLink="/contact-us">{{ 'LINK_CONTACTS'|translate }}</a></div>
    <div class="topbar__item-text"><a class="topbar__link" routerLink="/terms-and-conditions">Terms And Conditions</a></div>
    <div class="topbar__item-text"><a class="topbar__link" routerLink="/privacy-policy">Privacy Policy</a></div>

</ng-container>
<ng-container *ngIf="layout === 'classic'">
    <div class="topbar__item-text"><a class="topbar__link" routerLink="/about-us">{{ 'LINK_ABOUT_US'|translate }}</a></div>
    <div class="topbar__item-text"><a class="topbar__link" routerLink="/contact-us">{{ 'LINK_CONTACTS'|translate }}</a></div>
    <div class="topbar__item-text"><a class="topbar__link" routerLink="/terms-and-conditions">Terms And Conditions</a></div>
    <div class="topbar__item-text"><a class="topbar__link" routerLink="/privacy-policy">Privacy Policy</a></div>
    <div class="topbar__item-spring"></div>
</ng-container>
